module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av649-bfffa56ff67dc32a57baf945e923287a.jpg";